import React from 'react';
/**
 * @deprecated utiliser `ModalV2Content`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var ModaleContent = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, children));
};
export default ModaleContent;
